import { render } from "./LevelDetailPage.vue?vue&type=template&id=0eba4d44&ts=true"
import script from "./LevelDetailPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./LevelDetailPage.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/level/LevelDetailPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0eba4d44"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0eba4d44', __exports__)) {
    api.reload('0eba4d44', __exports__)
  }
  
  module.hot.accept("./LevelDetailPage.vue?vue&type=template&id=0eba4d44&ts=true", () => {
    api.rerender('0eba4d44', render)
  })

}


export default __exports__